import type { GetHomePageAccountSummaryResponse } from '@vy/api-definition';
import { GetHomePageAccountSummaryResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { USE_CACHE_HEADER } from '../../../services/api/cache-headers';
import type { CustomBaseUseQueryOptions } from '../requests-types/custom-use-query-options';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useHomePageAccountSummary(
  options?: CustomBaseUseQueryOptions<GetHomePageAccountSummaryResponse>,
) {
  return useQuery(
    queryKeys.homePageAccountSummary(),
    async () => {
      const api = getPrivateApi();

      const accountSummaryData = await api.getHomePageAccountSummary(USE_CACHE_HEADER);

      return GetHomePageAccountSummaryResponseSchema.parse(accountSummaryData);
    },
    { ...options },
  );
}
